import { useRecoilValue } from 'recoil';
import { ROLE_TYPE } from 'types/enumType';
import { SidebarItemType } from 'types/sidebar';
import { decryptString } from 'util/encryptUtil';

import { userInfoState } from 'globalState/user/atom';
import SidebarNavDepthItem from './SidebarNavDepthItem';
import SidebarNavItem from './SidebarNavItem';

type SidebarNavListProps = {
  items: SidebarItemType[];
};

export default function SidebarNavList({ items }: SidebarNavListProps) {
  const userInfo = useRecoilValue(userInfoState);
  return (
    <ul>
      {items &&
        items.map((item) => {
          if (
            (item.href === '/customer' || item.href === '/admin') &&
            decryptString(userInfo.role) !== ROLE_TYPE.SUPER_ADMIN
          ) {
            return null;
          }

          if (
            (item.href === '/gateway' || item.href === '/client') &&
            (decryptString(userInfo.role) == ROLE_TYPE.ADMIN ||
              decryptString(userInfo.role) == ROLE_TYPE.USER)
          ) {
            return null;
          }

          if (item.href === '/user' && decryptString(userInfo.role) === ROLE_TYPE.USER) {
            return null;
          }

          if (!item.children || item.children?.length === 0) {
            return <SidebarNavItem key={item.href} item={item} className={'depth-01'} />;
          }
          return (
            <SidebarNavDepthItem
              key={item.href}
              item={item}
              userRole={decryptString(userInfo.role)}
              className={'depth-01'}
            />
          );
        })}
    </ul>
  );
}
